const initialState = {
    currentStep: 1,
    contact: false,
    confirmationPageType: 0,
};

export default (state = initialState, action) => {
    switch (action.type) {

        case 'SET_CURRENT_STEP_SUCCESS': {

            return Object.assign({}, state, {
                'currentStep': action.step,
            });
        }
        case 'SET_CONFIRMATION_PAGE_TYPE': {

            return Object.assign({}, state, {
                'confirmationPageType': action.data,
            });
        }
        case 'SET_CURRENT_STEP_AND_CONTACT_SUCCESS': {

            if(action.step == state.currentStep) return {...state};
            return Object.assign({}, state, {
                'currentStep': action.step,
                'contact': action.data,
            });
        }
        default:
            return state
    }
}
